import React, { Component } from 'react'
import { connect } from 'react-redux'
import McActions from 'store/redux/mc'

import { pageData } from 'decorators'
import { translate } from 'react-i18next'
import { McGameStatusBar, Text, CopyToClipboard, Icon } from 'components'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'

import { McGameTabSeasons } from './McGameTabSeasons'
import { McGameTabResults } from './McGameTabResults'
import './McGame.css'

const isDev = process.env.NODE_ENV !== 'production'

@connect(
    state => ({
        game: state.mc.game,
        timeline: state.mc.timeline
    }),
    {
        requestGameData: McActions.requestGameData
    }
)
@translate()
@pageData({ title: 'Game Detail' })
export class McGame extends Component {
    state = {
        highlight: false,
        activeTab: 0
    }
    componentWillMount() {
        // TODO: Remove hide loading
        this.requestGameDataInterval = setInterval(() => {
            if (this.state.activeTab === 1) this.props.requestGameData({ gameCode: this.props.game.gameCode, panel: 'RANKING', hideLoading: true })
        }, 2000)
    }

    componentWillUnmount() {
        clearInterval(this.requestGameDataInterval)
    }

    onChangeTabSeasons = season => this.props.requestGameData({ gameCode: this.props.game.gameCode, season })

    onChangeTabGame = tab => {
        this.props.requestGameData({ gameCode: this.props.game.gameCode, panel: tab === 0 ? 'DECISIONS' : 'RANKING' })
        this.setState({ activeTab: tab })
    }

    renderNavItem = (link, index) => (
        <NavItem>
            <NavLink className={this.state.activeTab === index ? 'active' : ''} onClick={() => this.onChangeTabGame(index)}>
                {link}
            </NavLink>
        </NavItem>
    )

    render() {
        const { game, t } = this.props
        const { highlight, activeTab } = this.state

        if (!game) return null
        const { totalSeasons, totalRaces, currentRace, currentSeason, requestedSeason, seasons, ranking } = game

        return (
            <div className="McGame flex col-stretch">
                <McGameStatusBar game={game} />
                <section className="McGame-Content flex col-stretch">
                    <Nav tabs>
                        {this.renderNavItem(t('mc.game.nav.playerDecisions'), 0)}
                        {this.renderNavItem(t('mc.game.nav.resultsComparision'), 1)}
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId={0}>
                            <McGameTabSeasons
                                seasons={seasons}
                                totalSeasons={totalSeasons}
                                totalRaces={totalRaces}
                                currentRace={currentRace}
                                currentSeason={currentSeason}
                                requestedSeason={requestedSeason}
                                onChangeTab={this.onChangeTabSeasons}
                            />
                        </TabPane>
                        <TabPane tabId={1} className="Scrollable">
                            {ranking && <McGameTabResults currentSeasonNumber={currentSeason} currentSeason={ranking.currentSeason} lastSeason={ranking.lastSeason} />}
                        </TabPane>
                    </TabContent>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/Game/McGame.js